import { Box, Stack } from "@mui/material";
import React, { ReactNode, useEffect, useMemo, useState } from "react";

import parlors from "../../../constants/parlors_detail.json";
import { ClickEventType } from "../../../types";
import { customEvent } from "../../../utils";
import {
  deterministicShuffle,
  applySigunguFallback,
  haversineKm,
  formatDistance,
} from "./shuffle";

const 광주남문장례식장Id = 313;
// 시군구 단위 결과가 이 수 미만이면 시도 fallback.
// 3 = 서울 시군구 다수(종로/강남/서초 등 4개 시군구)가 시군구 단위로 표시되도록.
// 변경 후 1-2주 색인 추세 보고 조정.
const MIN_LIST_SIZE = 3;

export function DTypeParlorList({
  title,
  binsoAveragePrice,
  sido,
  sigungu,
  currentParlorId,
  currentLat,
  currentLng,
  CardViewType,
  event,
}: {
  sido?: string;
  sigungu?: string;
  currentParlorId?: string | number;
  currentLat?: number;
  currentLng?: number;
  title: string;
  binsoAveragePrice?: boolean;
  CardViewType: (res: any) => ReactNode;
  event?: ClickEventType;
}) {
  const parlorCardItems = useMemo(() => {
    const filtered = applySigunguFallback(parlors, sido, sigungu, MIN_LIST_SIZE);

    const target = filtered.find((p) => p.id === 광주남문장례식장Id);
    const others = filtered.filter((p) => p.id !== 광주남문장례식장Id);

    // 우선순위 1: 좌표 있으면 거리 계산 + 가까운 순 정렬 + distanceKm/distanceLabel 주입
    if (currentLat !== undefined && currentLng !== undefined) {
      const withDistance = others
        .map((p) => {
          const lat = Number((p as any).latitude);
          const lng = Number((p as any).longitude);
          if (isNaN(lat) || isNaN(lng)) return { ...p, distanceKm: null, distanceLabel: "" };
          const km = haversineKm(currentLat, currentLng, lat, lng);
          return { ...p, distanceKm: km, distanceLabel: formatDistance(km) };
        })
        .sort((a, b) => {
          if (a.distanceKm == null) return 1;
          if (b.distanceKm == null) return -1;
          return a.distanceKm - b.distanceKm;
        });
      return target ? [target, ...withDistance] : withDistance;
    }

    // 우선순위 2: 좌표 없으면 currentParlorId 시드 셔플
    const seed = currentParlorId !== undefined ? Number(currentParlorId) : NaN;
    const shuffled = !isNaN(seed) ? deterministicShuffle(others, seed) : others;

    return target ? [target, ...shuffled] : shuffled;
  }, [sigungu, sido, currentParlorId, currentLat, currentLng]);

  const [averagePrice, setaveragePrice] = useState(0);

  useEffect(() => {
    let price = 0;
    let binsoFullLength = 0;
    parlorCardItems.map((res) => {
      for (let i = 0; i < res.binsos.length - 1; i++) {
        price = price + Number(res.binsos[i].charge);
        binsoFullLength = binsoFullLength + 1;
      }
    });
    setaveragePrice(price / binsoFullLength);
  }, []);

  const onClickEvent = () => {
    if (event) {
      customEvent(event);
    }
  };

  return (
    <>
      <h2 className="subtitle_18_sb" style={{ marginBottom: "4px" }}>
        {title}
      </h2>
      {binsoAveragePrice && (
        <Box component="p" className="caption_12_m" mb="4px">
          전체 장례식장 기준 빈소이용료(1일) 평균 가격 :{" "}
          {Math.round(averagePrice).toLocaleString()}원
        </Box>
      )}
      <Box marginTop="6px" />
      <Stack component="ul" gap="16px" onClick={onClickEvent}>
        {parlorCardItems.map((res) => CardViewType(res))}
      </Stack>
    </>
  );
}
